import { waitForToken } from "../loaders/waitForToken";
import { normalizeRoutes } from "./normalizeRoutes";
import { privateRoutes } from "../PrivateRoutes";
import { matchPath } from "react-router-dom";

export const validateIsAuthorized = async () => {
  const rolePermissions = await waitForToken("persist:root");
  const roleData = JSON.parse(rolePermissions);
  const Permissions = JSON.parse(roleData.permission);
  const allPermisssions = Permissions?.applicationPermission;

  const normalizedPrivateRoutes = normalizeRoutes(privateRoutes);

  const currentRoute = normalizedPrivateRoutes.find((route) =>
    matchPath(route.path, window.location.pathname)
  );

  if (!currentRoute) return false;
  return currentRoute.Permissions.some((perm) => allPermisssions.includes(perm));
};
